import React from "react";
import { createPortal } from "react-dom";
import {
  CloseIcon,
} from "../../helper/HwIcon";

function CommonPopup({ show, setShow, children, title, headerClass, modalClass, bodyClass }) {
  return createPortal(
    <>
      <div className={`hw-modal fade ${show ? "show" : ""}`}>
        <div className={`hw-modal-dialog hw-modal-dialog-centered hw-modal-dialog-scrollable ${modalClass}`}>
          <div className="hw-modal-content">
            <div className={`hw-modal-header ${headerClass}`}>
              <div className="hw-modal-headerTitle">{title}</div>
              <button
                onClick={() => {
                  setShow(false);
                }}
                className="hw-modal--close"
              >
                <CloseIcon />
              </button>
            </div>
            <div className={bodyClass ? bodyClass : "hw-modal-body"}>{children}</div>
          </div>
        </div>
      </div>
      {show ? <div className="hw-modal-backdrop fade show" /> : ""}
    </>,
    document.body
  );
}

export default CommonPopup;
